
export const programMap = [
    {
        day: 'MERCOLEDÌ 12 MARZO 2025',
        image: "programma-1.jpg",
        sections: [
            {
                title: 'Pomeriggio',
                activities: [
                    "Arrivo in aeroporto a Marrakech",
                    "Trasferimento in bus dall’aeroporto alla Medina",
                    <>
                        Escursione in gruppi, visita del souk e degustazione di tè alla menta presso il Glacier
                        Cafè<span style={{color: '#d2202e', fontWeight: 'bold', fontFamily: 'Arial B'}}>*</span>
                        <br/>

                    </>,
                    <><span style={{fontWeight: 'bold'}}>ore 18:00/18:40</span> - Trasferimento verso l’hotel Kenzi Menara Palace </>,
                    <><span style={{fontWeight:'bold'}}>ore 18:20/19:00</span> - Check-in presso l’hospitality desk Ferrarelle </>,
                ],
                note: <><span style={{color: '#d2202e', fontWeight: 'bold', fontFamily: 'Arial B'}}>*</span>Desideriamo
                    sottolineare che la prima attività sarà l'escursione nei souk e si passerà in hotel soltanto dopo di
                    questa. Pertanto, sarà importante vestirsi adeguatamente e prepararsi con gli oggetti personali
                    necessari sin dal momento della partenza. <br/><br/></>
            },
            {
                title: 'Sera',
                activities: [
                    <><span style={{fontWeight: 'bold'}}>ore 20:15</span> - Appuntamento nella hall dell'hotel per
                        trasferimento verso il ristorante Palais Jad Mahal </>,
                    <><span style={{fontWeight: 'bold'}}>ore 20:45</span> - Welcome Dinner<span
                        style={{color: '#d2202e', fontWeight: 'bold', fontFamily: 'Arial B'}}>*</span> </>,
                    <><span style={{fontWeight: 'bold'}}>ore 23:30</span> - Partenza transfer per rientro in hotel </>
                ],
                note: <><span style={{color: '#d2202e', fontWeight: 'bold', fontFamily: 'Arial B'}}>*</span>Per la prima cena non vi è un dress code da rispettare.
                    <br/><br/></>
            }
        ]
    },
    {
        day: 'GIOVEDÌ 13 MARZO 2025',
        image: "programma-2.jpg",
        sections: [
            {
                title: 'Mattina',
                activities: [
                    <>
                        <span style={{fontWeight:'bold'}}>dalle ore 07:00 alle ore 09:00</span> - Colazione presso la sala breakfast dell’hotel
                    </>,
                    <><span style={{fontWeight:'bold'}}>ore 09:30</span> - Convention (1a parte) presso la sala Athlas<span style={{color:'#d2202e', fontWeight:'bold', fontFamily:'Arial B'}}>*</span>  </>,
                    <><span style={{fontWeight:'bold'}}>ore 13:00</span> - Pranzo a bordo piscina </>,
                ],
            },
            {
                title: 'Pomeriggio',
                activities: [
                    <>
                        <span style={{fontWeight:'bold'}}>ore 14:30</span> - Convention (2a parte) presso la sala Athlas
                    </>,
                    <><span style={{fontWeight:'bold'}}>dalle ore 17:00</span> - Tempo libero </>,
                ],
                note: <><span style={{color:'#d2202e', fontWeight:'bold', fontFamily:'Arial B'}}>*</span>Per il meeting è consigliato un dress code <span style={{fontWeight:'bold'}}>business casual</span> (no jeans). <br/><br/></>
            },
            {
                title: 'Sera',
                activities: [
                    <>
                        <span style={{fontWeight:'bold'}}>ore 20:00</span> - Appuntamento nella hall dell'hotel per trasferimento verso il Palais Soleiman
                    </>,
                    <><span style={{fontWeight:'bold'}}>ore 20:30</span> - Aperitivo presso il Fafas Bar </>,
                    <><span style={{fontWeight: 'bold'}}>ore 21:00</span> - Gala dinner<span
                        style={{color: '#d2202e', fontWeight: 'bold', fontFamily: 'Arial B'}}>*</span> </>,
                    <><span style={{fontWeight:'bold'}}>dalle ore 23:00 alle ore 00:30</span> - Open bar e dj set </>,
                    <><span style={{fontWeight:'bold'}}>ore 23:00</span> - Partenza 1° transfer per rientro in hotel </>,
                    <><span style={{fontWeight:'bold'}}>ore 00:30</span> - Partenza 2° transfer per rientro in hotel </>,
                ],
                note: <><span style={{color: '#d2202e', fontWeight:'bold', fontFamily:'Arial B'}}>*</span>È gradito un dress code <span style={{fontWeight:'bold'}}>elegante</span> per la cena di gala (per uomo camicia e giacca, la cravatta non è obbligatoria, no jeans).</>
            },
        ]
    },
    {
        day: 'VENERDÌ 14 MARZO 2025',
        image: "programma-3.jpg",
        sections: [
            {
                title: 'Mattina',
                activities: [
                    <>
                        <span style={{fontWeight:'bold'}}>dalle ore 06:00 alle ore 07:00</span> - Colazione presso la sala breakfast dell’hotel e check-out
                    </>,
                    <>
                        Transfer per l’aeroporto secondo i seguenti orari: <br/>
                        <span style={{fontWeight: 'bold'}}>ore 07:15 </span>- partenza gruppo per rientro su Milano
                        Malpensa (volo Easyjet U2 3928) <br/>
                        <span style={{fontWeight: 'bold'}}>ore 07:45 </span>- partenza gruppo per rientro su Napoli Capodichino (volo charter) <br/>
                    </>,
                ],
            },
        ]
    }
]
